<div class="AccountListing container-fluid py-3">
  <h3>Account Listing</h3>
  <app-table
    *ngIf="tableReady"
    [columns]="tableColumns"
    [dataSource]="dataSource"
    [selectable]="false"
    [dataSourceParams]="tableDataSourceParams"></app-table>
</div>
